
import * as objectConstants from '../constants/objectConstants';

export let SPECIIFIC_IMAGE_SIZES = [
    {
        constant: objectConstants.IMAGE_WIDTH_5,
        value: 5
    },
    {
        constant: objectConstants.IMAGE_WIDTH_10,
        value: 10
    },
    {
        constant: objectConstants.IMAGE_WIDTH_15,
        value: 15
    },
    {
        constant: objectConstants.IMAGE_WIDTH_20,
        value: 20
    },
    {
        constant: objectConstants.IMAGE_WIDTH_25,
        value: 25
    },
    {
        constant: objectConstants.IMAGE_WIDTH_30,
        value: 30
    },
    {
        constant: objectConstants.IMAGE_WIDTH_35,
        value: 35
    },
    {
        constant: objectConstants.IMAGE_WIDTH_40,
        value: 40
    },
];


export let ASSET_IMAGE_SIZES = [
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_10,
        value: 10
    },
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_15,
        value: 15
    },
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_20,
        value: 20
    },
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_25,
        value: 25
    },
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_30,
        value: 30
    },
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_35,
        value: 35
    },
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_40,
        value: 40
    }
];

export let TOP_ASSET_IMAGE_SIZES = [
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_10,
        value: 10
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_20,
        value: 20
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_30,
        value: 30
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_40,
        value: 40
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_50,
        value: 50
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_60,
        value: 60
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_70,
        value: 70
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_80,
        value: 80
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_90,
        value: 90
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_100,
        value: 100
    }
];


/** WEBPACK FOOTER **
 ** ./src/models/objectModels.js
 **/